import { render } from "./distribution-key-periods.vue?vue&type=template&id=5d1296f3"
import script from "./distribution-key-periods.vue?vue&type=script&lang=js"
export * from "./distribution-key-periods.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__